import request from '@/utils/request'

export function getCourseData(data_) {
    return request({
        url: '/api/vip/related_album',
        method: 'get',
        params: data_
    })
}